import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Scrolly from "./Scrolly";
import "../style/TopScrolly.scss";
import "../style/ScrollyPhoto.scss";

const TopScrolly = (props) => {
  const { steps, width, height } = props;
  const photoBoxEls = useRef([]);
  const photoEls = useRef([]);

  const [progress, setProgress] = useState({
    overallPct: 0,
    currentStep: 0,
    currentStepPct: 0,
  });

  useEffect(() => {
    updatePhoto(progress.currentStep);
  }, [progress.currentStep]);

  const updatePhoto = (currentStep) => {
    steps.map((d, i) => {
      if (i === currentStep) {
        // photoBoxEls.current[i].style.zIndex = -1;
        photoBoxEls.current[i].style.opacity = 1;

        // setTimeout(function () {
        // }, 150);
      } else {
        // photoBoxEls.current[i].style.zIndex = -10;
        photoBoxEls.current[i].style.opacity = 0;
      }
    });
  };

  return (
    <Scrolly onProgressHandler={setProgress} steps={steps}>
      {steps.map((step, stepIndex) => (
        <div
          className="scrolly-photo-box"
          style={{ zIndex: stepIndex === 0 ? -1 : -10 }}
          ref={(el) => (photoBoxEls.current[stepIndex] = el)}
          key={"scrolly-photo" + stepIndex}
        >
          <div className={`scrolly-photo-flex`}>
            {/* <img
              ref={(el) => (photoEls.current[stepIndex] = el)}
              className={`scrolly-photo`}
              src={`${process.env.PUBLIC_URL + "/" + step.img}`}
            /> */}

            {width > height ? (
              <img
                ref={(el) => (photoEls.current[stepIndex] = el)}
                className={`scrolly-photo`}
                src={`${process.env.PUBLIC_URL}/${step.img}`}
              />
            ) : (
              <div
                className={"scrolly-photo-mobile"}
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/${step.img_m})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            )}
          </div>
        </div>
      ))}
    </Scrolly>
  );
};

// TopScrolly.propTypes = {
//   /** An array of steps to scroll over */
//   steps: PropTypes.arrayOf(
//     PropTypes.shape({
//       text: PropTypes.string.isRequired,
//     })
//   ).isRequired,
// }

// TopScrolly.defaultProps = {
//   steps: [
//     { text: 'This is step 1' },
//     { text: 'This is step 2' },
//     { text: 'This is step 3' },
//   ],
// }

export default TopScrolly;
